export default {
  combine: {
    view_report: "@:ui.view Report",
    add_login: "@:ui.add Login",
    add_host: "@:ui.add Host",
    add_provider: "@:ui.add Provider",
    add_function: "@:ui.add Function",
    add_page: "@:ui.add Page",
    add_role: "@:ui.add Role",
    add_user: "@:ui.add User",
    edit_login: "@:ui.edit Login",
    edit_host: "@:ui.edit Host",
    edit_provider: "@:ui.edit Provider",
    edit_function: "@:ui.edit Function",
    edit_page: "@:ui.edit Page",
    edit_role: "@:ui.edit Role",
    edit_user: "@:ui.edit User",
    edit_password: "@:ui.edit @:ui.password",
    delete_login: "@:ui.delete Login",
    delete_host: "@:ui.delete Host",
    delete_provider: "@:ui.delete Provider",
    delete_function: "@:ui.delete Function",
    delete_page: "@:ui.delete Page",
    delete_role: "@:ui.delete Role",
    delete_user: "@:ui.delete User",
    assign_functions: "@:ui.assign Functions",
    assign_roles: "@:ui.assign Roles",
    confirm_password: "Confirm @:ui.password",
    change_password: "Change @:ui.password",
    old_password: "Old @:ui.password",
    new_password: "@:ui.new @:ui.password",
    account_status: "@:ui.account @:ui.status",
    account_settings: "@:ui.account @:ui.settings",
    layout_settings: "@:ui.layout @:ui.settings",
    add_bot: "@:ui.add Bot",
    edit_bot: "@:ui.edit Bot",
    delete_bot: "@:ui.delete Bot",
    assign_bot_login: "@:ui.assign Bot Login",
    vip_bot_login: "@:ui.vip Bot Login",
    add_proxy: "@:ui.add Proxy",
    edit_proxy: "@:ui.edit Proxy",
    delete_proxy: "@:ui.delete Proxy",
    assign_bot_proxy: "@:ui.assign Bot Proxy",
    map_league: "@:ui.map League",
    unmap_league: "@:ui.unmap League",
    map_team: "@:ui.map Team",
    unmap_team: "@:ui.unmap Team",
    add_match: "@:ui.add Match",
    map_match: "@:ui.map Match",
    unmap_match: "@:ui.unmap Match",
    add_league: "@:ui.add League",
    add_team: "@:ui.add Team",
    add_rtf: "@:ui.add RTF",
    edit_rtf: "@:ui.edit RTF",
    delete_rtf: "@:ui.delete RTF",
    unmap_list: "@:ui.unmap List",
    create_match: "@:ui.create Match",
    swap_map_match: "@:ui.swap Map Match",
    add_special_match: "@:ui.add Special Match",
    swap_remap_match: "@:ui.swap Remap Match",
    add_match_by_batch: "@:ui.add Match By Batch",
    switch_provider: "Switch Provider",
    add_ip: "@:ui.add IP",
    delete_ip: "@:ui.delete IP",
    otp_page: "OTP Page",
    unbind_otp_2fa: "Unbind OTP 2FA",
  },
  short: {
    swap_team: "ST",
    manual_add: "MA",
    manual_map: "MM",
    manual_create: "MC",
    remap: "RM",
    mark_fetch: "F",
    affect_value: "AV",
    cmd_enabled: "CMD",
    match_date: "Date",
    market_type: "Market",
    match_time: "Time",
    match_link: "Link",
    running_score: "RS",
    running_time: "RT",
    parent_league: "PL",
    match_provider: "MP",
    league_provider: "LP",
    home_provider: "HP",
    away_provider: "AP",
    outright: "OR",
    arrive_time: "A.T",
    deliver_time: "D.T",
    deliver_status: "D.S",
    arrive_time_in_ms: "A.T (ms)",
    deliver_time_in_ms: "D.T (ms)",
    danger_zone: "D.Z",
    sbo_running_score: "SBO RS",
    ibc_running_score: "IBC RS",
    sbo_running_time: "SBO RT",
    ibc_running_time: "IBC RT",
    date_generated: "DG.T",
    receive_time: "R.T",
    process_time: "P.T",
    db_time: "DB.T",
    process_time_in_ms: "P.T (ms)",
    db_time_in_ms: "DB.T (ms)",
    delay_time_in_ms: "DL.T (ms)",
    arrived_time_in_ms: "A.T (ms)",
    sbo_home_red_card: "SBO HRC",
    sbo_away_red_card: "SBO ARC",
    ibc_home_red_card: "IBC HRC",
    ibc_away_red_card: "IBC ARC",
    home_red_card: "HRC",
    away_red_card: "ARC",
  },
  ok: "OK",
  cancel: "Cancel",
  apply: "Apply",
  login: "Login",
  logout: "Logout",
  home: "Home",
  away: "Away",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  refresh: "Refresh",
  assign: "Assign",
  action: "Action",
  id: "ID",
  name: "Name",
  all: "All",
  search: "Search",
  remove: "Remove",
  save: "Save",
  load: "Load",
  account: "Account",
  settings: "Settings",
  on: "ON",
  off: "OFF",
  new: "New",
  clear: "Clear",
  system: "System",
  functions: "Function | Functions",
  pages: "Page | Pages",
  roles: "Role | Roles",
  users: "User | Users",
  username: "Username",
  password: "Password",
  created_on: "Create On",
  active: "Active",
  disabled: "Disabled",
  blocked: "Blocked",
  suspended: "Suspended",
  page_size: "Page Size",
  no_data: "No Data Available",
  status: "Status",
  login_attempt: "Login Attempt",
  user_roles: "Roles",
  layout: "Layout",
  mustang: "Real Time System",
  providers: "Provider | Providers",
  hosts: "Host | Hosts",
  proxies: "Proxy | Proxies",
  proxy_id: "Proxy ID",
  proxy_host: "Proxy Host",
  proxy_port: "Proxy Port",
  proxy_remark: "Remarks",
  ports: "Port | Ports",
  providerid: "Provider ID",
  url: "URL",
  hostid: "Host ID",
  fullname: "Full Name",
  view: "View",
  moreinfo: "More Info",
  robot: "Robot",
  model: "Model",
  result: "Result",
  success: "Success",
  version: "Version",
  hostname: "Host Name",
  ipaddress: "IP Address",
  machine: "Machine",
  platform: "Platform",
  cpupercentage: "CPU Percentage",
  virtualmemory: "Virtual Memory",
  runtime: "Run Time",
  target: "Target",
  server: "Server",
  payload: "Payload",
  close: "Close",
  omcache: "Cache",
  time: "Time",
  event: "Event",
  hdp: "HDP",
  ou: "OU",
  oe: "OE",
  onextwo: "1X2",
  first_half: "First Half",
  second_half: "Second Half",
  odds: "Odd | Odds",
  even: "even",
  bots: "BOT | BOTS",
  time_sync: "Time Sync",
  bot_login: "Bot Login",
  free_login: "Available Login",
  bot_proxy: "Bot Proxy",
  free_proxy: "Available Proxies",
  full_time: "Full Time",
  half_time: "Half Time",
  first_goal: "First Goal",
  last_goal: "Last Goal",
  no_goal: "No Goal",
  double_chance: "Double Chance",
  total_goal: "Total Goal",
  hh: "HH",
  hd: "HD",
  ha: "HA",
  dh: "DH",
  dd: "DD",
  da: "DA",
  ah: "AH",
  ad: "AD",
  aa: "AA",
  ml: "ML",
  market: "Market",
  sports: "Sport | Sports",
  sport_id: "Sport ID",
  bet_type: "Bet Type",
  back: "Back",
  show: "Show",
  matches: "Match | Match",
  leagues: "League | Leagues",
  league_id: "League ID",
  league_name: "League Name",
  league_nation: "League Nation",
  sbo_link: "SBO Link",
  ibc_link: "IBC Link",
  cmd_link: "CMD Link",
  sbo: "SBO",
  ibc: "IBC",
  cmd: "CMD",
  sbo_map: "SBO Map",
  ibc_map: "IBC Map",
  cmd_map: "CMD Map",
  epoch_time: "Epoch Time",
  link_id: "Link ID",
  mark_fetch : "Mark Fetch",
  linked: "Linked",
  fetched: "Fetched",
  teams: "Team | Teams",
  team_name: "Team Name",
  team_nation: "Team Nation",
  configuration: "Configuration",
  monitor: "Monitor",
  list: "List",
  login_id: "Login ID",
  login_name: "Login Name",
  filter: "Filter",
  ascending: "Ascending",
  descending: "Descending",
  map_league: "Map League",
  map_team: "Map Team",
  map_match: "Map Match",
  mapped: "Mapped",
  not_mapped: "Not Mapped",
  map: "Map",
  unmap: "Unmap",
  match: "Match",
  match_date: "Match Date",
  market_type: "Market Type",
  match_link: "Match Link",
  match_time: "Match Time",
  is_live: "Is Live",
  sbo_match: "SBO Match",
  cmd_match: "CMD Match",
  ibc_match: "IBC Match",
  linked_match: "Linked Match",
  early: "Early",
  today: "Today",
  live: "Live",
  not_linked: "Not Linked",
  cmd_enabled: "CMD Enabled",
  affect_value: "Affect Value",
  semi_auto: "Semi Auto",
  ldiff: "Ldiff",
  auto_open: "Auto Open",
  manual_link: "Manual Link",
  swap_team: "Swap Team",
  swap_map: "Swap Map",
  swap: "Swap",
  job_control: "Job Control",
  job_control_sport: "Job Control Sport",
  reports: "Report | Reports",
  odds_log: "Odds Log",
  odds_id: "Odds Id",
  match_id: "Match Id",
  manual_add: "Manual Add",
  manual_map: "Manual Map",
  running_score: "Running Score",
  running_time: "Running Time",
  parent_league: "Parent League",
  ot: "Odds Type",
  mt: "Market Type",
  sync: "Sync",
  sbo_login: "SBO Login",
  ibc_login: "IBC Login",
  cmd_login: "CMD Login",
  sbo_bot: "SBO BOTS",
  ibc_bot: "IBC BOTS",
  cmd_bot: "CMD BOTS",
  logs: "Log | Logs",
  action_log: "Action Log",
  date_time: "DateTime",
  status_desc: "Status Desc",
  ip_address: "Ip Address",
  domain_name: "Domain Name",
  browser_agent: "Browser Agent",
  action_by: "Action By",
  target_id: "Target ID",
  target_action: "Target Action",
  details: "Details",
  key: "Key | Keys",
  value: "Value | Values",
  sort: "Sort",
  next: "Next",
  from: "From",
  to: "To",
  unmap_match: "Unmap Match",
  unmap_list: "Unmap List",
  match_provider: "Match Provider",
  league_provider: "League Provider",
  home_provider: "Home Team Provider",
  away_provider: "Away Team Provider",
  update_mapping: "Update Mapping",
  duplicate_match_list: "Duplicate Match List",
  current_match: "Current Match",
  running_ball: "Running Ball",
  danger_zone: "Danger Zone",
  danger_zone_corner: "Danger Zone Corner",
  danger_zone_booking: "Danger Zone Booking",
  danger_zone_goal_kick: "Danger Zone Goal Kick",
  match_feed: "Match Feed",
  match_feed_2: "Match Feed 2",
  rtf_commentary: "RTF Commentary",
  play_state: "Play State",
  play_time: "Play Time",
  info: "Info",
  last_info: "Last Info",
  rtf_name: "RTF Name",
  description: "Description",
  rtf: "RTF",
  report_stats: "Report Statistics",
  rtf_id: "RTF Id",
  rtf_name: "RTF Name",
  last_update_time: "Last Update Time",
  event_id: "Event Id",
  map_outright: "Map Outright",
  remap_match: "Remap Match",
  remap: "Remap",
  sbo_prefer: "SBO Prefer",
  ibc_prefer: "IBC Prefer",
  change_date: "Change Date",
  match_datetime: "Match DateTime",
  current_league: "Current League",
  remap_league: "Remap League",
  remap_team: "Remap Team",
  sbo_league: "SBO League",
  ibc_league: "IBC League",
  current_team: "Current Team",
  sbo_team: "SBO Team",
  ibc_team: "IBC Team",
  prefer: "Prefer",
  create: "Create",
  linked_match_info: "Linked Match Info",
  sbo_match_info: "SBO Match Info",
  ibc_match_info: "IBC Match Info",
  match_info: "Match Info",
  match_datetime: "Match DateTime",
  manual_create: "Manual Create",
  pre_add_match: "Pre Add Match",
  console: "Console",
  check: "Check",
  sbo_self_map: "SBO Self Map",
  ibc_self_map: "IBC Self Map",
  mapped_time: "Mapped Time",
  add_special: "Add Special",
  type: "Type",
  fulltime: "Fulltime",
  corners: "Corners",
  specific: "Specific",
  specials: "Specials",
  bookings: "Bookings",
  both_one_ng: "Both/One/Neither Team To Score",
  three_way_hdp_full: "3-Way Handicap (Full Time)",
  three_way_hdp_half: "3-Way Handicap (Half Time)",
  clean_sheet: "Clean Sheet",
  to_win_to_nil: "To Win To Nil",
  highest_scoring_half: "Highest Scoring Half",
  draw_no_bet: "Draw No Bet",
  both: "Both",
  one: "One",
  home_yes: "Home Yes",
  home_no: "Home No",
  away_yes: "Away Yes",
  away_no: "Away No",
  tie: "Tie",
  full_time_ml: "Full Time Money Line",
  half_time_ml: "Half Time Money Line",
  full_time_oe: "Full Time OE",
  half_time_oe: "Half Time OE",
  purge_match: "Purge Match",
  remark: "Remark",
  purge_league: "Purge League",
  purge_sbo_league: "Purge SBO League",
  purge_team: "Purge Team",
  purge_sbo_team: "Purge SBO Team",
  team_id: "Team ID",
  map_match_other_sport: "Map Match Others",
  add_by_batch: "Add By Batch",
  criteria: "Criteria",
  search_input: "Search Input",
  league_log: "League Log",
  team_log: "Team Log",
  match_log: "Match Log",
  map_league_log: "Map League Log",
  map_team_log: "Map Team Log",
  purge_league_log: "Purge League Log",
  purge_team_log: "Purge Team Log",
  request_json: "Request JSON",
  log: "Log",
  detail_id: "Detail Id",
  action_name: "Action Name",
  sp_name: "SP Name",
  step: "Step",
  audit_table_name: "Audit Table Name",
  audit_log: "Audit Log",
  old: "Old",
  input_league_id: "Input League Id",
  prefer_provider: "Prefer Provider",
  add_league_provider: "Add League Provider",
  input_team_id: "Input Team Id",
  add_team_provider: "Add Team Provider",
  purge_sbo_match_log: "Purge SBO Match Log",
  purge_ibc_match_log: "Purge IBC Match Log",
  linked_match_log: "Linked Match Log",
  map_match_log: "Map Match Log",
  pre_add_match_log: "Pre Add Match Log",
  purge_match_log: "Purge Match Log",
  provider_log: "Provider Log",
  host_log: "Host Log",
  login_log: "Login Log",
  proxy_log: "Proxy Log",
  bot_log: "Bot Log",
  job_control_log: "Job Control Log",
  sport_log: "Sport Log",
  configuration_logs: "Configuration Logs",
  monitor_logs: "Monitor Logs",
  league_logs: "League Logs",
  team_logs: "Team Logs",
  match_logs: "Match Logs",
  full_half: "Full Half",
  created_time: "Created Time",
  bot_login_log: "Bot Login Log",
  bot_proxy_log: "Bot Proxy Log",
  outright: "Outright",
  is_outright: "Is Outright",
  arrive_time_in_ms: "Arrive Time In Ms",
  deliver_time_in_ms: "Deliver Time In Ms",
  arrive_time: "Arrive Time",
  deliver_time: "Deliver Time",
  deliver_status: "Deliver Status",
  ref_id: "Ref ID",
  provider_id: "Provider ID",
  host_id: "Host ID",
  match_count: "Match Count",
  sbo_home: "SBO Home",
  sbo_away: "SBO Away",
  ibc_home: "IBC Home",
  ibc_away: "IBC Away",
  add_match: "Add Match",
  add_match_by_batch: "Add Match By Batch",
  add_special_match: "Add Special Match",
  map_match: "Map Match",
  map_swap_match: "Map Swap Match",
  create_match: "Create Match",
  update_ldiff: "Update Ldiff",
  update_aff_value: "Update Aff Value",
  pre_add_match: "Pre Add Match",
  pre_add_match_cmd: "Pre Add Match CMD",
  purge_ibc_match: "Purge IBC Match",
  purge_sbo_match: "Purge SBO Match",
  purge_match: "Purge Match",
  add_league: "Add League",
  map_league: "Map League",
  purge_league: "Purge League",
  update_prefer: "Update Prefer",
  add_team: "Add Team",
  map_team: "Map Team",
  purge_team: "Purge Team",
  add_provider: "Add Provider",
  delete_provider: "Delete Provider",
  edit_provider_info: "Edit Provider Info",
  provider_disabled: "Provider Disabled",
  add_host: "Add Host",
  delete_host: "Delete Host",
  edit_host_info: "Edit Host Info",
  host_disabled: "Host Disabled",
  add_login: "Add Login",
  delete_login: "Delete Login",
  edit_login_info: "Edit Login Info",
  login_disabled: "Login Disabled",
  update_password: "Update Password",
  add_proxy: "Add Proxy",
  delete_proxy: "Delete Proxy",
  edit_proxy_info: "Edit Proxy Info",
  proxy_disabled: "Proxy Disabled",
  add_bot: "Add Bot",
  delete_bot: "Delete Bot",
  edit_bot_info: "Edit Bot Info",
  bot_disabled: "Bot Disabled",
  update_login: "Update Login",
  update_proxy: "Update Proxy",
  update_time_sync: "Update Time Sync",
  failed: "Failed",
  unlink_parent: "Unlink Parent",
  unlink: "Unlink",
  match_clear_rs_rt: "Match Clear RS / RT",
  match_clear_rs: "Match Clear Running Score",
  match_clear_rt: "Match Clear Running Time",
  sbo_running_score: "SBO Running Score",
  ibc_running_score: "IBC Running Score",
  sbo_running_time: "SBO Running Time",
  ibc_running_time: "IBC Running Time",
  purge_ibc_team: "Purge IBC Team",
  non_live: "Non Live",
  clear_rs_rt_all: "Clear RS & RT All",
  match_clear_rs_rt_all: "Match Clear RS & RT All",
  rs_rt_control: "RS / RT Control",
  arrived_time_in_ms: "Arrived Time In Ms (B-A)",
  process_time_in_ms: "Process Time In Ms (C-B)",
  db_time_in_ms: "DB Insert Time In Ms (D-C)",
  delay_time_in_ms: "Delay Time In Ms (D-A)",
  date_generated: "RB Side Sent Out Data's Time (A)",
  receive_time: "End Point Receive Data's Time (B)",
  process_time: "After Process Data's Time (C)",
  db_time: "Data Insert Into DB's Time (D)",
  repull: "Repull",
  rb_data: "RB Data",
  send: "Send",
  rb_data_detail: "RB Data Detail",
  repull_data_detail: "Repull Data Detail",
  sbo_home_red_card: "SBO Home Red Card",
  sbo_away_red_card: "SBO Away Red Card",
  ibc_home_red_card: "IBC Home Red Card",
  ibc_away_red_card: "IBC Away Red Card",
  match_clear_rc: "Match Clear Red Card",
  home_red_card: "Home Red Card",
  away_red_card: "Away Red Card",
  efight_logs: "eFight Logs",
  efight_api_log: "eFight API Log",
  video: "Video",
  request: "Request",
  response: "Response",
  efight_api_log_info: "eFight API Log Info",
  view_log: "View Log",
  view_output: "View Output",
  efight_api_output_info: "eFight API Output Info",
  output: "Output",
  vip: "VIP",
  vip_bot_login: "VIP Bot Login",
  alert: "Alert",
  delete_disabled_login: "Delete Disabled Login",
  assigned: "Assigned",
  cmd_sbo_mapping: "CMD/SBO Mapping",
  cmd_sbo_switching: "CMD/SBO Switching",
  sbo_to_cmd: "SBO to CMD",
  cmd_to_sbo: "CMD to SBO",
  current: "Current",
  purge_mapping: "Purge Mapping",
  switch_provider: "Switch Provider",
  is_backup: "Is Backup",
  yes: "Yes",
  no: "No",
  prefer_id: "Prefer ID",
  ibc_ibt_mapping: "IBC/IBT Mapping",
  ibc_ibt_switching: "IBC/IBT Switching",
  ibt_to_ibc: "IBT to IBC",
  ibc_to_ibt: "IBC to IBT",
  outright_double_match: "Outright Double Match",
  ip: "IP",
  updated_by: "Updated By",
  your_ip: "Your IP : ",
  purge_ibc_league: "Purge IBC League",
  status_account: "Status (Account)",
  pre_add_match_pending: "Pre Add Match Pending",

  // OTP 2FA Translations
  setup_otp_via_mobile_authenticator: "Set up OTP via Mobile Authenticator",
  step_1_download_google_authenticator: "1. Download Google Authenticator on your device.",
  step_2_create_account_scan_qr: "2. Create an account by scanning this QR code with Google Authenticator.",
  step_3_enter_6_digit_code_verify: "3. Enter the 6-digits code generated by Google Authenticator into the textbox below and then click Verify to complete the registration.",
  download_on_app_store: "Download on the App Store",
  get_it_on_google_play: "Get it on Google play",
  regenerate_qr: "Regenerate QR",
  unable_to_scan_qr_code: "Unable to scan the QR code?",
  manual_entry_secret: "Manual entry secret",
  otp: "OTP",
  verify: "Verify",
  enable_otp_via_mobile_authenticator_app: "Enable OTP via Mobile Authenticator App",
  two_factor_authenticator_bound: "Two-factor authenticator bound",
  unbind: "Unbind",
  setup_2fa: "Setup 2FA",
  enter_6_digit_code: "Enter 6-digit code",
  verification_code: "Verification Code",

  submit: "Submit",
  validated: "Validated",
  validated_at: "Validated At",
};
